import React, {Component} from 'react';
import Document from "../../Listview/Document/Document";
import Octicon, {ChevronUp, ChevronDown} from '@githubprimer/octicons-react';
import './Accordion.css';
import Logo from "../Logo/Logo";

class Accordion extends Component {

  render() {
    var parent = "#accordion" + this.props.container;
    var parent2 = "accordion" + this.props.panel.id;
    var container = "#collapse" + this.props.panel.id;
    var container2 = "collapse" + this.props.panel.id;
    let docsfromgroups = [];
    let accordionContent = [];
    if (this.props.panel.message) {
      accordionContent = <div dangerouslySetInnerHTML={{__html: this.props.panel.message}}/>
    } else if (this.props.panel.categories) {
      accordionContent = <div id={parent2}>
        {this.props.panel.categories.map(function (item, index) {
          return <Accordion height={this.props.height} width={this.props.width} panel={item}
                            key={index}
                            container={this.props.panel.id} changeRoute={this.props.changeRoute}
                            setFile={this.props.setFile}/>
        }.bind(this))}
      </div>

    } else if (this.props.panel.documents !== null) {

      docsfromgroups = this.props.panel.documents;
      var documents = Object.keys(docsfromgroups).map(function(key) {
        return docsfromgroups[key]
      });
      if (documents.length !== 0) {
        accordionContent = documents.map(function (itemGroup, indexa) {

          var lastItem = (documents.length === indexa + 1);
          let hasLogo = false;
          if(this.props.panel.existingLogos && this.props.panel.existingLogos[indexa] !== undefined){
            hasLogo = true;
          }
            return(<div key="{indexa}" className={indexa}>
              {hasLogo &&
                  <div className="group-header">
                    <div className="group-logo">
                      <Logo url={this.props.panel.existingLogos[indexa].path}/>
                    </div>
                  </div>
              }

              <table className="table document-list">
                <tbody>
                {itemGroup.map(function (item, index) {
                  return <Document height={this.props.height} width={this.props.width} document={item} key={index}
                                   setCategory={this.props.setCategory} changeRoute={this.props.changeRoute}
                                   setFile={this.props.setFile}/>
                }.bind(this))}
                </tbody>
              </table>
              {!lastItem &&
              <hr/>
              }

            </div>)
          }.bind(this))
      }
    }

    return <div className="card">
      <div className="card-header">
        <a data-toggle="collapse" href={container} className="card-link collapsed no-select">{this.props.panel.title}
          <Octicon className="accordion-closed" icon={ChevronDown}/>
          <Octicon className="accordion-opened" icon={ChevronUp}/>
        </a>
      </div>
      <div id={container2} className="collapse" data-parent={parent}>
        <div className="card-body">
          {accordionContent}
        </div>
      </div>
    </div>
  }
}

export default Accordion;



// WEBPACK FOOTER //
// ./src/Components/Elements/Accordion/Accordion.js